import { InjectionToken } from '@angular/core';

export interface UIKitConfig {
  solidButtons: string[];
  frameButtons: string[];
  clearButtons: string[];
  progressBar: string[];
  toggleSwitchBar: string[];
  roundBar: string[];
  badges: string[];
  checkboxes: string[];
  toggles: string[];
  defaultSelect?: string;
  modalRoot: boolean;
}

export const UI_KIT_CONFIG = new InjectionToken<UIKitConfig>('UI_KIT_CONFIG');
